<ion-header mode="ios">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="closePage()">
        <ion-icon [src]="'/assets/icons/' + capacitor.scheme + '/x.svg'"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{ capacitor.translateString('Help') }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding www">
  <ion-grid>
    <div itemscope itemtype="https://schema.org/FAQPage">

      <div class="help">
        <h1>{{ capacitor.translateString('Help') }}</h1>
        <p>Welcome to our frequently asked questions! Please look below if you have any questions about our product of features. Cannot find your answer? Please send us a message.</p>
        <button ion-button (click)="openSupport();" class="cta medium blue shadow" *ngIf="auth">Send us a message</button>
      </div>

      <ion-accordion-group *ngFor="let section of data?.help">
        <h3 class="margin">{{ section?.category }}</h3>
        <ion-accordion itemscope itemprop="mainEntity" itemtype="https://schema.org/Question" *ngFor="let question of section?.questions">
          <ion-item itemprop="name" slot="header">{{ question?.question }}</ion-item>
          <div class="answer ion-padding" slot="content" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
            <div itemprop="text" [innerHTML]="question?.answer"></div>
          </div>
        </ion-accordion>
      </ion-accordion-group>
      
    </div>
  </ion-grid>
</ion-content>
